const Description = ({ text }) => {
  const base =
    'w-full text-bodyMobile md:text-bodyDesktop text-olive text-center md:text-left font-chivoMono mt-smallMobile lg:mt-mediumDesktop'

  return (
    <div className={base}>
      <p>{text}</p>
    </div>
  )
}

export default Description
